module.exports = __webpack_public_path__ + "static/media/icon-default.caea9ce7.svg";